var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTxt = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3.429 1h12.137L22 7.168v14.457c0 .76-.64 1.375-1.429 1.375H3.43C2.64 23 2 22.385 2 21.625V2.375C2 1.615 2.64 1 3.429 1Z",
  fill: "#9CA4B5"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.98 7.188H17c-.788 0-1.428-.616-1.428-1.375V1.014l6.407 6.174Z",
  fill: "#768198"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.293 13.871H7.586V18.5H6.215v-4.629H4.539v-1.059h4.754v1.06ZM11.996 14.703l.93-1.89h1.566l-1.59 2.82 1.633 2.867h-1.582l-.957-1.926-.957 1.926H9.461l1.629-2.867-1.586-2.82h1.562l.93 1.89ZM19.45 13.871h-1.708V18.5h-1.37v-4.629h-1.677v-1.059h4.754v1.06Z",
  fill: "#fff"
})));
export default SvgTxt;